export default "<button type=\"button\" class=\"btn btn-secondary-outline mli-btn\" (click)=\"goBack()\">Go Back</button>"